export const getOrdersApiRespMock = {
    count: 45902,
    next: 'https://api.n.exchange/en/api/v1/orders/?format=json&page=2&page_size=5',
    previous: null,
    results: [
        {
            amount_base: '2.25283844',
            is_default_rule: false,
            unique_reference: 'ORLPQA',
            amount_quote: '0.01558767',
            pair: {
                name: 'XMRBTC',
                base: { code: 'XMR', name: 'monero' },
                quote: { code: 'BTC', name: 'bitcoin' },
                fee_ask: '0.04000000',
                fee_bid: '0.04000000',
            },
            withdraw_address: {
                type: 'W',
                name: '',
                address:
                    '4AbnZ8XFpPvbYwhcXN5JMbYqwtPd9oX6reVvpuNAdjp649UUDmGAHspg6ZvMfSrkgxa9urKGEnBw5AgZ4gTN44C1C3Jyt2g',
                currency_code: 'XMR',
            },
            deposit_address: {
                type: 'D',
                name: '',
                address: '32cA6NVTSE2kSxtYokujJ2hsYU2WTLkU4t',
                currency_code: 'BTC',
            },
            created_on: '2020-12-23T05:56:42.717818Z',
            from_default_rule: false,
            payment_window: 15,
            payment_deadline: '2020-12-23T06:11:42.717818Z',
            kyc_deadline: null,
            status_name: [[15, 'RELEASED']],
            transactions: [
                {
                    created_on: '2020-12-23T06:02:21.871143Z',
                    modified_on: '2020-12-23T06:07:05.602665Z',
                    type: 'W',
                    address_to: 26741,
                    tx_id: 'fde1a6681da34474989b22c3d70350e9e3719316590a091143f9c0f005f9446f',
                    confirmations: 0,
                    amount: '2.25283844',
                    is_verified: false,
                    is_completed: false,
                    time: '2020-12-23T06:02:21.870715Z',
                    currency: 'XMR',
                },
                {
                    created_on: '2020-12-23T05:57:08.433697Z',
                    modified_on: '2020-12-23T06:02:20.637819Z',
                    type: 'D',
                    address_to: 28213,
                    tx_id: '4a2927cb9d19f8c5439dfb3051050ea953da43fe1fe900b7d097f9245cd66261',
                    confirmations: 2,
                    amount: '0.01558767',
                    is_verified: false,
                    is_completed: false,
                    time: '2020-12-23T05:56:58Z',
                    currency: 'BTC',
                },
            ],
            referral_code: [
                {
                    code: 'R4RMF0BXG97',
                    created_on: '2020-12-23T05:56:42.613867Z',
                    modified_on: '2020-12-23T05:56:42.613895Z',
                },
            ],
            withdrawal_fee: 0.015,
            withdrawal_fee_quote: 0.0001031004,
            user_provided_amount: 1,
        },
        {
            amount_base: '1.19706881',
            is_default_rule: false,
            unique_reference: 'OVSACE',
            amount_quote: '544.99969000',
            pair: {
                name: 'XMRXRP',
                base: { code: 'XMR', name: 'monero' },
                quote: { code: 'XRP', name: 'ripple' },
                fee_ask: '0.04500000',
                fee_bid: '0.04500000',
            },
            withdraw_address: {
                type: 'W',
                name: '',
                address:
                    '42PxjxeSTor6hNrc9V4SFWAQna3dvRKyt9isePi1F499YRT9AMz3JBPGV9hSYCxUX8A8bT6xyGwu75QZF6NrYXuP4Y4EwyS',
                currency_code: 'XMR',
            },
            deposit_address: {
                type: 'D',
                name: '',
                address: 'rHgcFpY57m6T4jzLLyBVZrnh2qajXbKUGd',
                currency_code: 'XRP',
            },
            created_on: '2020-12-23T05:51:13.682401Z',
            from_default_rule: false,
            payment_window: 15,
            payment_deadline: '2020-12-23T06:06:13.682401Z',
            kyc_deadline: null,
            status_name: [[15, 'RELEASED']],
            transactions: [
                {
                    created_on: '2020-12-23T05:53:08.125097Z',
                    modified_on: '2020-12-23T06:07:06.381336Z',
                    type: 'W',
                    address_to: 28212,
                    tx_id: 'c601756179f198e09b8cbdd7f9ba370f6466e1e21f0239e17d2c1b02e33b66e5',
                    confirmations: 6,
                    amount: '1.19706881',
                    is_verified: false,
                    is_completed: false,
                    time: '2020-12-23T05:53:08.124662Z',
                    currency: 'XMR',
                },
                {
                    created_on: '2020-12-23T05:51:29.561850Z',
                    modified_on: '2020-12-23T05:53:06.898727Z',
                    type: 'D',
                    address_to: 110,
                    tx_id: '43C0370D277925FE821CEE1AD1169C8B5B50657FD4EF316EFBDC59550C25A27F',
                    confirmations: 1,
                    amount: '544.99969000',
                    is_verified: false,
                    is_completed: false,
                    time: '2020-12-23T05:51:29.561184Z',
                    currency: 'XRP',
                },
            ],
            referral_code: [
                {
                    code: 'RCKFJNM9YSY',
                    created_on: '2020-12-23T05:51:13.496761Z',
                    modified_on: '2020-12-23T05:51:13.496780Z',
                },
            ],
            withdrawal_fee: 0.015,
            withdrawal_fee_quote: 6.7446627531,
            user_provided_amount: 1,
        },
        {
            amount_base: '0.02163731',
            is_default_rule: false,
            unique_reference: 'OIHADF',
            amount_quote: '0.00085550',
            pair: {
                name: 'ETHBTC',
                base: { code: 'ETH', name: 'ethereum' },
                quote: { code: 'BTC', name: 'bitcoin' },
                fee_ask: '0.03500000',
                fee_bid: '0.03500000',
            },
            withdraw_address: {
                type: 'W',
                name: '',
                address: '0x6A35800ca0aCE3542269B4a209d79C9fDAE668Cb',
                currency_code: 'ETH',
            },
            deposit_address: {
                type: 'D',
                name: '',
                address: '3PSbcC2iXLae7tpYzmaJCf2wq9Yo4p3Eus',
                currency_code: 'BTC',
            },
            created_on: '2020-12-23T05:46:20.913498Z',
            from_default_rule: false,
            payment_window: 15,
            payment_deadline: '2020-12-23T06:01:20.913498Z',
            kyc_deadline: null,
            status_name: [[16, 'COMPLETED']],
            transactions: [
                {
                    created_on: '2020-12-23T06:02:24.119957Z',
                    modified_on: '2020-12-23T06:06:04.984470Z',
                    type: 'W',
                    address_to: 28210,
                    tx_id: '0xc95e15c522330b8d3ea5d129229d3ea9791f8fbc4a1103958044fcd07df3e721',
                    confirmations: 20,
                    amount: '0.02163731',
                    is_verified: false,
                    is_completed: false,
                    time: '2020-12-23T06:02:24.119433Z',
                    currency: 'ETH',
                },
                {
                    created_on: '2020-12-23T05:46:28.336208Z',
                    modified_on: '2020-12-23T06:02:20.745988Z',
                    type: 'D',
                    address_to: 28211,
                    tx_id: '8a05d8ea9cab31a310cb699b4b12249a6eadc83714893719e48f9023148d015b',
                    confirmations: 2,
                    amount: '0.00085550',
                    is_verified: false,
                    is_completed: false,
                    time: '2020-12-23T05:46:26Z',
                    currency: 'BTC',
                },
            ],
            referral_code: [
                {
                    code: 'RZO1ASFVG1T',
                    created_on: '2020-12-23T05:46:20.784981Z',
                    modified_on: '2020-12-23T05:46:20.785004Z',
                },
            ],
            withdrawal_fee: 0.01,
            withdrawal_fee_quote: 0.0002704086,
            user_provided_amount: 1,
        },
        {
            amount_base: '0.27884826',
            is_default_rule: false,
            unique_reference: 'ORKFNX',
            amount_quote: '0.00200964',
            pair: {
                name: 'XMRBTC',
                base: { code: 'XMR', name: 'monero' },
                quote: { code: 'BTC', name: 'bitcoin' },
                fee_ask: '0.04000000',
                fee_bid: '0.04000000',
            },
            withdraw_address: {
                type: 'W',
                name: '',
                address:
                    '44agtzXoUfMeuGcNCwauZBdGX1hw63TJADADzTBGAAUBLfjBVhMxcofP5uMZoZHHVce65FwRf7F41ev4GRvGLWD9MzaiAXG',
                currency_code: 'XMR',
            },
            deposit_address: {
                type: 'D',
                name: '',
                address: '36MestobJbeCS7xtCiiK3fVwxQ9L8PPxp2',
                currency_code: 'BTC',
            },
            created_on: '2020-12-23T05:38:03.265323Z',
            from_default_rule: false,
            payment_window: 15,
            payment_deadline: '2020-12-23T05:53:03.265323Z',
            kyc_deadline: null,
            status_name: [[15, 'RELEASED']],
            transactions: [
                {
                    created_on: '2020-12-23T05:44:42.240686Z',
                    modified_on: '2020-12-23T06:07:07.035054Z',
                    type: 'W',
                    address_to: 28208,
                    tx_id: '229136317ca451b2a83001f48d6c4f5551d757ecce35508b190fce31df67f989',
                    confirmations: 9,
                    amount: '0.27884826',
                    is_verified: false,
                    is_completed: false,
                    time: '2020-12-23T05:44:42.240284Z',
                    currency: 'XMR',
                },
                {
                    created_on: '2020-12-23T05:38:28.513734Z',
                    modified_on: '2020-12-23T05:44:40.421133Z',
                    type: 'D',
                    address_to: 28209,
                    tx_id: '175291742d777376985c62301827c05b2bb79665d1c42784162526ac373624d1',
                    confirmations: 2,
                    amount: '0.00200964',
                    is_verified: false,
                    is_completed: false,
                    time: '2020-12-23T05:38:12Z',
                    currency: 'BTC',
                },
            ],
            referral_code: [
                {
                    code: 'RUQBBN22JSE',
                    created_on: '2020-12-23T05:38:03.160492Z',
                    modified_on: '2020-12-23T05:38:03.160510Z',
                },
            ],
            withdrawal_fee: 0.015,
            withdrawal_fee_quote: 0.0001025856,
            user_provided_amount: 1,
        },
        {
            amount_base: '0.67372308',
            is_default_rule: false,
            unique_reference: 'OQA9LX',
            amount_quote: '305.99910000',
            pair: {
                name: 'XMRXRP',
                base: { code: 'XMR', name: 'monero' },
                quote: { code: 'XRP', name: 'ripple' },
                fee_ask: '0.04500000',
                fee_bid: '0.04500000',
            },
            withdraw_address: {
                type: 'W',
                name: '',
                address:
                    '4AZ636G7Zx8M3x5Uha1PQL8fwXVcY5wYz5D2bnjbrpozTUXwXGfCKWGcHjtsnnkcR6N6js6rwnCxAADHtyahd1Qi5FZtiim',
                currency_code: 'XMR',
            },
            deposit_address: {
                type: 'D',
                name: '',
                address: 'rHgcFpY57m6T4jzLLyBVZrnh2qajXbKUGd',
                currency_code: 'XRP',
            },
            created_on: '2020-12-23T05:32:54.906849Z',
            from_default_rule: false,
            payment_window: 15,
            payment_deadline: '2020-12-23T05:47:54.906849Z',
            kyc_deadline: null,
            status_name: [[16, 'COMPLETED']],
            transactions: [
                {
                    created_on: '2020-12-23T05:35:45.498514Z',
                    modified_on: '2020-12-23T06:01:06.419390Z',
                    type: 'W',
                    address_to: 28207,
                    tx_id: 'ad267f22b96286b3c958a5b338774a9832b5db2c66767207b3413f27744b7159',
                    confirmations: 10,
                    amount: '0.67372308',
                    is_verified: false,
                    is_completed: false,
                    time: '2020-12-23T05:35:45.498155Z',
                    currency: 'XMR',
                },
                {
                    created_on: '2020-12-23T05:33:12.519037Z',
                    modified_on: '2020-12-23T05:34:19.096117Z',
                    type: 'D',
                    address_to: 110,
                    tx_id: '444F4A87A07D5CCD9F5C883B074D1B532F504A2B09CC91B5BC3ABA9D9FB7ABE7',
                    confirmations: 1,
                    amount: '305.99910000',
                    is_verified: false,
                    is_completed: false,
                    time: '2020-12-23T05:33:12.518347Z',
                    currency: 'XRP',
                },
            ],
            referral_code: [
                {
                    code: 'RWD9Z6NT9WN',
                    created_on: '2020-12-23T05:32:54.772866Z',
                    modified_on: '2020-12-23T05:32:54.772884Z',
                },
            ],
            withdrawal_fee: 0.015,
            withdrawal_fee_quote: 6.6644876691,
            user_provided_amount: 1,
        },
    ],
}
